var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPerson = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 11 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12V10.7766C1 8.48969 3.01532 6.6366 5.50127 6.6366C7.98468 6.6366 10 8.48969 10 10.7766V12H1Z",
    stroke: "#383E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53906 2.86271C3.53906 1.83401 4.41705 1 5.50125 1C6.58292 1 7.46217 1.83401 7.46217 2.86271C7.46217 3.8914 6.58292 4.72542 5.50125 4.72542C4.41705 4.72542 3.53906 3.8914 3.53906 2.86271Z",
    stroke: "#383E41"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPerson, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Person.9ed03d99.svg";
export { ForwardRef as ReactComponent };